import React from 'react'
import { imagePath } from 'frontend_core/dist/helpers/image'
import { defaultLocale } from 'server/i18n'
import {
  GoogleTagManagerHead,
  GoogleTagManagerBody,
} from 'components/business/shared/GoogleTagManager'
import HeaderContainer from 'containers/business/HeaderContainer/home'
import Footer from 'components/business/shared/Footer'
import GlobalStyle from 'styles'

export default function ErrorLayout(props) {
  const title = i18n.t(
    `error.${props.status}.title` || 'server.shared.default_title',
  )
  const description = i18n.t(`error.${props.status}.description`) || ''
  const siteName = i18n.t('server.shared.default_site_name')

  function renderRoot() {
    return (
      <div>
        <HeaderContainer {...props} />
        {props.children}
        <Footer {...props} />
      </div>
    )
  }

  function renderAll() {
    return (
      <html>
        <head>
          <meta charSet="utf-8" />
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no"
          />
          <title>{`${title} | ${siteName}`}</title>
          <meta name="description" content={description} />
          <link
            rel="stylesheet"
            href={manifest['business/legacy.css']}
            media="screen"
          />
          <link
            rel="stylesheet"
            href={manifest['business/main.css']}
            media="screen"
          />
          <link
            href="https://use.fontawesome.com/releases/v5.0.10/css/all.css"
            rel="stylesheet"
          />
          <link rel="dns-prefetch" href="//stay.spacemarket.com" />
          <link
            rel="apple-touch-icon"
            href={imagePath('common/apple-touch-icon.png')}
          />
          <GoogleTagManagerHead />
          <script
            src="https://browser.sentry-cdn.com/4.5.4/bundle.min.js"
            crossOrigin="anonymous"
          />
        </head>
        <body className="site-service">
          <div id="js-root">{renderRoot()}</div>
          <GoogleTagManagerBody />
          <GlobalStyle />
        </body>
      </html>
    )
  }
  return props.config.SSR ? renderAll() : renderRoot()
}
